/**
 * Assessment Duration Validation Utility
 * 
 * Determines if assessment results should be flagged as low-confidence
 * based on completion time.
 */

// Minimum thresholds in seconds
const SINGLE_ASSESSMENT_MIN_SECONDS = 30;
const DUAL_ASSESSMENT_MIN_SECONDS = 60;

/**
 * Checks if an assessment was completed too quickly to be reliable
 */
export function isLowConfidenceResult(durationSeconds: number | null | undefined, isDual: boolean): boolean {
  if (durationSeconds === null || durationSeconds === undefined) {
    return false; // Can't determine confidence without duration data
  }
  
  const threshold = isDual ? DUAL_ASSESSMENT_MIN_SECONDS : SINGLE_ASSESSMENT_MIN_SECONDS;
  return durationSeconds < threshold;
}

/**
 * Get the minimum expected duration for a given assessment type
 */
export function getMinimumDuration(isDual: boolean): number {
  return isDual ? DUAL_ASSESSMENT_MIN_SECONDS : SINGLE_ASSESSMENT_MIN_SECONDS;
}
